// src/websocket/http_poll.ts
import { Constant } from "../config/constant";
export class LongPollClient {
    constructor(opts) {
        var _a, _b, _c, _d;
        this.isRunning = false;
        this.endpoint = opts.endpoint;
        this.connectionId = opts.initialConnectionId;
        this.onMessages = opts.onMessages;
        this.onError = opts.onError;
        this.retryDelayMs = (_a = opts.retryDelayMs) !== null && _a !== void 0 ? _a : 1000;
        this.connectionId = opts.initialConnectionId;
        this.getAuthHeaders = opts.getAuthHeaders;
        this.onMessages = opts.onMessages;
        this.onError = opts.onError;
        this.retryDelayMs = (_b = opts.retryDelayMs) !== null && _b !== void 0 ? _b : 1000;
        this.emptyPollDelayMs = (_c = opts.emptyPollDelayMs) !== null && _c !== void 0 ? _c : 500;
        this.maxEmptyPollDelayMs = (_d = opts.maxEmptyPollDelayMs) !== null && _d !== void 0 ? _d : 5000;
    }
    start(connectionId) {
        if (this.isRunning)
            return;
        if (connectionId)
            this.connectionId = connectionId;
        this.isRunning = true;
        this.pollLoop();
    }
    stop() {
        var _a;
        this.isRunning = false;
        (_a = this.abortController) === null || _a === void 0 ? void 0 : _a.abort();
    }
    async pollLoop() {
        var _a;
        let backoffEmpty = this.emptyPollDelayMs;
        while (this.isRunning) {
            this.abortController = new AbortController();
            const signal = this.abortController.signal;
            try {
                // build URL with connection_id if present
                const url = new URL(Constant.LPOLL, window.location.origin);
                if (this.connectionId) {
                    url.searchParams.set("connection_id", this.connectionId);
                }
                const headers = await this.getAuthHeaders();
                const resp = await fetch(url.toString(), {
                    signal,
                    headers,
                });
                if (resp.status === 204) {
                    await this.delay(backoffEmpty);
                    backoffEmpty = Math.min(backoffEmpty * 2, this.maxEmptyPollDelayMs);
                    continue;
                }
                if (!resp.ok) {
                    throw new Error(`Longpoll error ${resp.status}`);
                }
                backoffEmpty = this.emptyPollDelayMs;
                const data = await resp.json();
                // save new connection_id if first time
                if (!this.connectionId) {
                    this.connectionId = data.connection_id;
                }
                // dispatch messages
                if (data.messages && data.messages.length) {
                    this.onMessages(data.messages);
                }
                // immediately loop again
            }
            catch (err) {
                if (err.name === "AbortError") {
                    // stop() was called
                    return;
                }
                // network or server error → notify and backoff
                (_a = this.onError) === null || _a === void 0 ? void 0 : _a.call(this, err);
                await this.delay(this.retryDelayMs);
            }
        }
    }
    delay(ms) {
        return new Promise((res) => setTimeout(res, ms));
    }
}
